import { ACTION_PREVIEW_PARTS } from './actionPreviewParts';
import type { ActionPreviewStyleConfig } from './types';

export const ACTION_PREVIEW_STYLE_CONFIG: ActionPreviewStyleConfig = {
  parts: ACTION_PREVIEW_PARTS,
  baseStyle: () => {
    return {
      container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        border: '1px solid',
        borderColor: 'separator.border',
        borderRadius: 'md',
        overflow: 'hidden',
        mb: 0.5,
        mx: -0.75,
      },
      header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        bg: 'page.plateLight',
        h: 3.5,
        px: 1,
      },
      title: {
        fontSize: 'sm',
        lineHeight: 'sm',
        color: 'feature.primary',
        fontWeight: 'heavy',
        p: 0,
        m: 0,
      },
      badge: {
        // Badge styles are handled by the Badge component itself
        // This is just a placeholder for potential custom styling
      },
      content: {
        display: 'flex',
        flexDirection: 'column',

        borderTop: '1px solid',
        borderColor: 'separator.divider',
      },
      footer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        h: 5,
        gap: 1,
        pr: 1,
        pl: 1.5,
        borderTop: '1px solid',
        borderColor: 'separator.divider',
      },
    };
  },
  defaultProps: {},
};
